import React from 'react';
import { LockIcon, ShieldCheckIcon, DownloadIcon, UserCheckIcon, HeadphonesIcon } from 'lucide-react';
import { PaymentBadges } from './PaymentBadges';
export function TrustBar() {
  const items = [{
    icon: LockIcon,
    title: 'Pagamento Sicuro',
    desc: 'Crittografia SSL 256-bit'
  }, {
    icon: ShieldCheckIcon,
    title: 'Garanzia 100%',
    desc: '45 giorni di prova'
  }, {
    icon: DownloadIcon,
    title: 'Accesso Immediato',
    desc: 'Download istantaneo'
  }, {
    icon: UserCheckIcon,
    title: 'Privacy Protetta',
    desc: 'Dati personali al sicuro'
  }, {
    icon: HeadphonesIcon,
    title: 'Supporto Dedicato',
    desc: 'Assistenza via email'
  }];
  return <section className="bg-white border-y border-gray-200 py-12 px-4" data-id="element-316">
      <div className="max-w-6xl mx-auto" data-id="element-317">
        <div className="text-center mb-10" data-id="element-318">
          <div className="flex items-center justify-center gap-2 text-gray-900 mb-2" data-id="element-319">
            <LockIcon className="w-6 h-6 text-green-600" data-id="element-320" />
            <h2 className="text-2xl font-bold" data-id="element-321">Transazione Sicura al 100%</h2>
          </div>
          <p className="text-gray-500" data-id="element-322">
            I tuoi dati sono protetti e crittografati
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mb-10" data-id="element-323">
          {items.map((item, idx) => {
          const Icon = item.icon;
          return <div key={idx} className="flex flex-col items-center text-center" data-id="element-324">
                <div className="w-12 h-12 rounded-full bg-blue-50 flex items-center justify-center text-blue-600 mb-3" data-id="element-325">
                  <Icon className="w-6 h-6" data-id="element-326" />
                </div>
                <h3 className="font-bold text-gray-900 text-sm mb-1" data-id="element-327">
                  {item.title}
                </h3>
                <p className="text-xs text-gray-500" data-id="element-328">{item.desc}</p>
              </div>;
        })}
        </div>

        <div className="pt-8 border-t border-gray-100 flex justify-center" data-id="element-329">
          <PaymentBadges data-id="element-330" />
        </div>
      </div>
    </section>;
}